import { Package, Sparkles } from "lucide-react";

const ChildModuleReviewCard = ({ child, originalChild }) => {
  const subModules = child.SUBSCRIBED_SUBMODULE_DETAILS || [];

  // PRICE CALCULATION (correct field)
  const subModulesTotal = subModules.reduce((sum, sub) => {
    return sum + Number(sub?.CUSTOM_PRICE || 0);
  }, 0);

  const originalSubs = originalChild?.SUBMODULES_DATA || [];

  return (
    <div className="rounded-2xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      {/* HEADER */}
      <div className="p-5">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          {/* LEFT */}
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-violet-100 dark:bg-violet-500/10 text-violet-700 dark:text-violet-300">
              <Package className="w-4 h-4" />
            </div>

            <div>
              <div className="flex items-center gap-2 flex-wrap">
                <h6 className="text-base font-semibold text-slate-800 dark:text-white">
                  {originalChild?.MODULE_NAME}
                </h6>

                <span className="px-2 py-1 rounded-full text-[10px] font-semibold uppercase tracking-wider bg-violet-100 dark:bg-violet-500/10 text-violet-700 dark:text-violet-300">
                  Child Module
                </span>
              </div>

              <p className="text-xs mt-1 text-slate-500 dark:text-slate-400">
                Module price is not added separately. Only selected submodule
                prices are included.
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="text-right">
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Submodule Total
            </p>

            <p className="text-2xl font-bold text-violet-600 dark:text-violet-300">
              ${subModulesTotal.toFixed(2)}
            </p>
          </div>
        </div>
      </div>

      {/* SUBMODULES */}
      {subModules.length > 0 && (
        <div className="px-5 pb-5 pt-4 border-t border-slate-200 dark:border-slate-800">
          <div className="flex items-center gap-2 mb-4">
            <Sparkles className="w-4 h-4 text-teal-500" />

            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
              Selected Sub Modules
            </p>
          </div>

          <div className="flex flex-wrap gap-3">
            {subModules.map((sub) => {
              const originalSub = originalSubs.find(
                (s) => String(s.SUBMODULE_ID) === String(sub.SUBMODULE_ID),
              );

              if (!originalSub) return null;

              return (
                <div
                  key={sub.SUBMODULE_ID}
                  className="px-4 py-3 rounded-2xl border border-teal-200 dark:border-teal-500/20 bg-teal-50 dark:bg-teal-500/10"
                >
                  <div className="text-sm font-semibold text-teal-700 dark:text-teal-300">
                    {originalSub.SUBMODULE_NAME}
                  </div>

                  <div className="text-xs mt-1 text-slate-500 dark:text-slate-400">
                    +${Number(sub.CUSTOM_PRICE || 0).toFixed(2)}/month
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChildModuleReviewCard;
